const DeviceType = {
  All: "999",
  Web: "1",
  App: "2",
  WeChat: "3",
  None: "0"
};

export default DeviceType;
